<div *ngIf="!loading">
  <div class="spinner"></div>
  <p class="text-center" style="color: #777;margin: -70px 0 100px;">Carregando solicitação, por favor aguarde ...
  </p>
</div>

<div *ngIf="loading" class="animated fadeIn">
  <div class="timeline-body">
    <div class="form-group">
      <label for="imput2">2.1 – Titulo da Proposta:</label>
      <input [(ngModel)]="sinteseProposta.tituloProposta" type="text" class="form-control" id="imput2">
    </div>

    <div class="form-group">
      <label for="imput3">2.2 – Identificação do Objeto</label>
      <p class="help-block">Breve descrição, clara e objetiva, da situação problema que se deseja
        melhorar/minimizar, quais serão as ações
        para financiamento com os recursos solicitados e os resultados esperados</p>
      <textarea [(ngModel)]="sinteseProposta.identificacaoObjeto" class="form-control" rows="3" id="imput3"></textarea>
    </div>

    <div class="form-group">
      <label for="imput4">2.3 – Objetivo Geral da Proposta</label>
      <p class="help-block">Relacionando com a situação problema que se deseja enfrentar com a execução do
        objeto</p>
      <textarea [(ngModel)]="sinteseProposta.objetivoGeralProposta" class="form-control" rows="3"
        id="imput4"></textarea>
    </div>

    <div class="form-group">
      <label for="imput5">2.4 – Objetivos Específicos da Proposta</label>
      <p class="help-block">Devem apresentar de forma detalhada o objetivo geral, relacionando com os resultados
        a serem atingidos</p>
      <textarea [(ngModel)]="sinteseProposta.objetivoEspecificoProposta" class="form-control" rows="3"
        id="imput5"></textarea>
    </div>

    <div class="form-group">
      <label for="imput6">2.5 – Justificativa da Proposta</label>
      <p class="help-block">Deve expor os argumentos e as considerações sobre as necessidades que justificam a
        realização das ações/atividades
        propostas, indicando como irá contribuir para a mudança da situação problema apresentada. É a
        justificativa
        que fundamenta a proposta</p>
      <textarea [(ngModel)]="sinteseProposta.justificativaProposta" class="form-control" rows="3"
        id="imput6"></textarea>
    </div>

    <div class="form-group">
      <label for="imput7">2.6 – Abrangência da proposta:</label>
      <textarea [(ngModel)]="sinteseProposta.abrangenciaProposta" class="form-control" rows="3" id="imput7"></textarea>
    </div>

    <div class="form-group">
      <label for="imput8">2.7 – Público Beneficiário</label>
      <p class="help-block">Direto e Indireto</p>
      <textarea [(ngModel)]="sinteseProposta.publicoBeneficiario" class="form-control" rows="3" id="imput8"></textarea>
    </div>


    <div class="form-group">
      <label for="imput9">2.7.1 – Perfil do Público Beneficiário Direto:</label>
      <p class="help-block">Indicar faixa etária, renda, escolaridade, condições de moradia</p>
      <textarea [(ngModel)]="sinteseProposta.perfilPublicoBeneficiario" class="form-control" rows="3"
        id="imput9"></textarea>
    </div>

    <div class="form-group">
      <label for="imput10">2.8 – Meta de Atendimento:</label>
      <textarea [(ngModel)]="sinteseProposta.metaAtendimento" class="form-control" rows="3" id="imput10"></textarea>
    </div>


    <div class="col-md-12 no-padding" style="background-color: #0073b7;">
      <div class="col-md-12">
        <label>2.9 – Período Referência para Execução do Objeto:</label>
      </div>
      <div class="col-md-6">
        <label for="imput11">Início:</label>
        <input [(ngModel)]="sinteseProposta.dataIniExecucao" type="date" class="form-control" id="imput11">
      </div>
      <div class="col-md-6">
        <label for="imput12">Fim:</label>
        <input [(ngModel)]="sinteseProposta.dataFimExecucao" type="date" class="form-control" id="imput12">
      </div>
      <div class="col-md-12">
        <br>
      </div>
    </div>


    <div class="form-group">
      <label for="imput13">2.10 – Metodologia e Abordagem da Proposta:</label>
      <p class="help-block">Deve descrever como serão realizadas as ações/atividades, incluindo as estratégias e
        os procedimentos detalhados
        para a sua execução. É a maneira pela qual os objetivos serão alcançados</p>
      <textarea [(ngModel)]="sinteseProposta.metodologiaAbordagemProposta" class="form-control" rows="3"
        id="imput13"></textarea>
    </div>

  </div>

  <div class="timeline-footer">
    <a class="btn btn-primary btn-sm" (click)="modificaSinteseProposta()">Realizar ajuste</a>
  </div>
</div>